import React from 'react';
import PropTypes from 'prop-types';

import { registerDecoration } from 'core/forms';

import { Button } from 'uikit/buttons';

const FormDecorationButton = ({ schema }) => (
  <Button
    text={schema.text}
    variant="outlined"
    onClick={schema.handleOnClick}
    />
);

FormDecorationButton.propTypes = {
  schema: PropTypes.shape({
    text: PropTypes.string.isRequired,
    handleOnClick: PropTypes.func.isRequired,
  }).isRequired,
};

registerDecoration('Button', React.memo(FormDecorationButton));

export default FormDecorationButton;
